import 'leaflet';
const version = '0.0.1';

class MapInstanceObjects{
    static init(element){
        var $element = $(element);
        if($element.data('map-instance')){
            return $element.data('map-instance');
        }else{
            let instance = new MapInstanceObjects(element)
            $element.data('map-instance', instance);
            return instance
        }
    }

    constructor(element) {
        this.$element = $(element);
        this.element = element;
        this.initMap();
    }

    initMap(){
        this.map = L.map('map', {
            scrollWheelZoom: false,
            zoomControl: false,
            fullscreenControl: true
        });
        this.renderer = L.canvas({ padding: 0.5 });
        L.control.zoom({
            position: 'topright'
        }).addTo(this.map);
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png").addTo(this.map);
        /*
        if(localStorage.getItem('center')){
            this.map.setView(localStorage.getItem('center').split(','), localStorage.getItem('zoom'));
        }else{
         */
            this.map.setView([54.9003, 23.9333], 8);
        //}

        if(this.$element.data('id'))
        {
            this.loadObject(this.$element.data('id'));
        }
        else{
            this.loadAllTypeObjects(this.$element.data('type'));
        }

        this.map.once('focus', function() {
            this.map.scrollWheelZoom.enable();
        }.bind(this));

        $('.m_location').click(function(e){
            e.preventDefault();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                        var locationIcon = L.icon({
                            iconUrl: '/assets/images/map_icons/marker-icon.png',
                            iconSize: [25, 41],
                            iconAnchor: [12, 41],
                        });
                        this.map.setView([position.coords.latitude, position.coords.longitude], 8);
                        L.marker([position.coords.latitude, position.coords.longitude], {icon: locationIcon}).addTo(this.map);
                    }.bind(this),
                    function errorCallback(error) {
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                alert("User denied the request for Geolocation.");
                                break;
                            case error.POSITION_UNAVAILABLE:
                                alert("Location information is unavailable.");
                                break;
                            case error.TIMEOUT:
                                alert("The request to get user location timed out.");
                                break;
                            case error.UNKNOWN_ERROR:
                                alert("An unknown error occurred.");
                                break;
                        }
                    });
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        }.bind(this));
    }
    loadObject(id){
        $.get('/api/gis/object', {id: id}).done(function (result){

            var markerIcon = L.icon({
                iconUrl: result.icon,
                iconSize: [30, 30],
                iconAnchor: [15, 15], // point of the icon which will correspond to marker's location
            });

            var lineStyle = {
                "color": "#fca030",
                "dashArray": '5, 10',
                "weight": 5
            };
            if (result.geojson.LineString) {
                L.geoJson(result.geojson.LineString, {
                    renderer: this.renderer,
                    style: lineStyle
                }).addTo(this.map);
            }
            if (result.geojson.MultiLineString) {
                L.geoJson(result.geojson.MultiLineString, {
                    renderer: this.renderer,
                    style: lineStyle
                }).addTo(this.map);
            }

            if(result.geojson.MultiPoint)
            {
                L.geoJson(result.geojson.MultiPoint, {
                    renderer: this.renderer,
                    pointToLayer: function (feature, latlng) {
                        return L.marker(latlng, {icon: markerIcon});
                    }
                }).addTo(this.map);
                this.map.setView([result.geodata.properties.longitude, result.geodata.properties.latitude], 13);
            }
            else if(result.geodata)
            {
                L.geoJson(result.geodata, {
                    renderer: this.renderer,
                    pointToLayer: function (feature, latlng) {
                        return L.marker(latlng, {icon: markerIcon}
                        )/*.on('click', function() { //popup perziuroje nereikia
                            var that = this;
                            $.get('/gis/popupData', {
                                id: feature.properties.id,
                                type: 'Objects'
                            }).done(function (result){
                                if (result) {
                                    that.bindPopup(result).openPopup();
                                }
                            });
                        });*/
                    }
                }).addTo(this.map);
                this.map.setView([result.geodata.properties.longitude, result.geodata.properties.latitude], 13);
            }
        }.bind(this));
    }

    loadAllTypeObjects(id){
        $.get('/api/gis/objects_by_kind', {id: id}).done(function (result){

            var markerIcon = L.icon({
                iconUrl: result.icon,
                iconSize: [20, 20],
                iconAnchor: [10, 10], // point of the icon which will correspond to marker's location
            });

            if(result.geodata)
            {
                var bounds = L.latLngBounds();
                L.geoJson(result.geodata, {
                    onEachFeature: function(feature, layer) {
                        let lat_lng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]]
                        bounds.extend(lat_lng);
                    },
                    renderer: this.renderer,
                    pointToLayer: function (feature, latlng) {
                        return L.marker(latlng, {icon: markerIcon}
                        ).on('click', function() {
                            var that = this;
                            $.get('/gis/popupData', {
                                id: feature.properties.id,
                                type: 'Objects'
                            }).done(function (result){
                                if (result) {
                                    that.bindPopup(result).openPopup();
                                }
                            });
                        });
                    }
                }).addTo(this.map);

                this.map.fitBounds(bounds);
            }
        }.bind(this));
    }
}

export default MapInstanceObjects;